export const asArray = (x) => {
    switch (true) {
        case !x:
            return [];
        case Array.isArray(x):
            return x;
        default:
            return [x];
    }
};
export const makeFrom = (address, name) => !name || name === '' ? address : { name, address };
